module.exports = __webpack_public_path__ + "cffd2f13254a6b2dc7d55829d68c722a.pdf";